import { LitElement, html, css } from 'lit';
import { BootstrapCSS } from '../../resources/css/bootstrap.css';
import { EplibStyles } from '../../resources/css/style.css.js';

export class EplibReviewView extends LitElement {

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles
    ];
  }

  async firstUpdated() {
    super.firstUpdated();
    document.title = 'EarlyPrint Library Review Corrections';
    document.querySelector("meta[name='description']").setAttribute('content', 'Review suggested corrections to the texts in the EarlyPrint Library');
  }

  render() {
    return html`
    <div class="container-fluid">
      <div class="row actions">
        <div class="col-lg-12">
          <p/>
        </div>
      </div>
      <div class="row list-browse">
        <div class="col-md-3">
          <eplib-text-filter-form channel="review"></eplib-text-filter-form>
        </div>
        <div class="col-md-6">
          <div class="container-fluid">
            <div id="content-inner" class="container-fluid well well-sm">
              <div class="row">
                  <span style="font-size: 10px;">
                      <span>Legend: </span>
                      <span style="background-color: #fff7a9">pending</span>
                      <span style="background-color: #f2ba05">autocorrect</span>
                      <span style="background-color: #bbd5b5">accepted</span>
                      <span style="background-color: salmon">rejected</span>
                  </span>
              </div>
              <!-- Fake the annotation pane toggle into working -->
              <span hidden="true" class="swap btn"></span>
              <eplib-review></eplib-review>
            </div>
          </div>
        </div>
        <div id="annotation-filter" class="col-md-3">
          <eplib-annotation-filter-form></eplib-annotation-filter-form>
        </div>
      </div>
    </div>
  `;
  }
}

customElements.define('eplib-review-view', EplibReviewView);